var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1 0 0 1 0 -987.362121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3336"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#0000ff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M1.31 1019.74 C1.31 1002.55 15.4 988.6 32.74 988.6 C50.09 988.6 64.17 1002.55 64.17 1019.74 C64.17 1036.92 50.09 1050.88 32.74 1050.88 C15.4 1050.88 1.31 1036.92 1.31 1019.74 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3338"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M18.81 1019.42 C18.81 1011.98 24.81 1005.93 32.2 1005.93 C39.59 1005.93 45.6 1011.98 45.6 1019.42 C45.6 1026.86 39.59 1032.9 32.2 1032.9 C24.81 1032.9 18.81 1026.86 18.81 1019.42 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tspan3344",
    transform: "matrix(1.013192 0 0 0.98698 24.075824 1005.889953)"
  }, /*#__PURE__*/React.createElement("text", {
    kerning: 0,
    fontFamily: ".AppleSystemUIFont",
    fontWeight: 700,
    fontSize: 21.93
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.2
  }, "2"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2B);
export default __webpack_public_path__ + "static/media/2B.d8924a01fcaf0de5e787495766754115.svg";
export { ForwardRef as ReactComponent };